import { render, staticRenderFns } from "./suoritemerkintojen-kategoriat.vue?vue&type=template&id=56713bec&scoped=true&"
import script from "./suoritemerkintojen-kategoriat.vue?vue&type=script&lang=ts&"
export * from "./suoritemerkintojen-kategoriat.vue?vue&type=script&lang=ts&"
import style0 from "./suoritemerkintojen-kategoriat.vue?vue&type=style&index=0&id=56713bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56713bec",
  null
  
)

export default component.exports